"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdultServiceLegalityAssessmentDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdultServiceLegalityAssessmentDescription = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.adult_service_legality_assessment_description.label',
    fallbackLabel: 'What methods do you use to assess and ensure the legality and legitimacy of the services or products your merchants offer? How do you ensure that the content provided by merchants does not contain illegal material, and what specific verification techniques and continuous monitoring practices do you employ to oversee the content? Could you also describe any guidelines or controls in place to ensure that materials meet your standards. Please include any safety measures like contractual obligations, lists of permissible content, and any automated processes you might use.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adult_service_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
